import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
// import './bs.css';
// import './site.css';
import App from './App';

window.renderHRMRecruitmentComponent = function () {
  const config = window.HRMRecruitmentComponentConfiguration;

  let root = document.getElementById('ag-rc-root');

  if(!root.attachShadow)
  {
      root.innerHTML = "Vaš trenutni brskalnik ni popolnoma združljiv s tem spletnim mestom. Za največjo produktivnost/učinkovitost priporočamo enega od teh brskalnikov: Chrome, Edge, Safari ali Firefox.";
      return;
  }

  let shadow = root.attachShadow({mode: 'open'});

  new ReactDOM.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    shadow
  );
}

//window.renderHRMRecruitmentComponent();

